import { api } from '../../app/api/baseApi';

export const loadGroupsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createLoadGroups: builder.mutation({
            query: (arg: any) => {
                // Allow callers to opt out of the global error toast for this call.
                // baseApi reads `suppressErrorToast` from the args object.
                const { suppressErrorToast, ...body } = arg ?? {};
                return {
                    url: '/dm/v1/load-groups',
                    method: 'POST',
                    body,
                    suppressErrorToast,
                };
            },
        }),
        getLoadGroupsList: builder.query<any, any>({
            query: (body: any) => ({
                url: '/dm/v1/load-groups/filter',
                method: 'POST',
                body,
            }),
            providesTags: ['LoadGroups'],
        }),
        getLoadGroupsListAll: builder.query<object, any>({
            query: (body: any) => ({
                url: '/dm/v1/load-groups/filter',
                method: 'POST',
                body,
            }),
        }),
        getloadGroupsById: builder.query<any, any>({
            query: ({ loadGroupId, body }: { loadGroupId: any; body: any }) => ({
                url: `/dm/v1/load-groups/${loadGroupId}/filter`,
                method: 'POST',
                body,
            }),
            providesTags: ['LoadGroupsById'],
        }),
        updateLoadGroups: builder.mutation({
            query: ({ loadGroupId, body }: { loadGroupId: any; body: any }) => ({
                url: `/dm/v1/load-groups/${loadGroupId}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result, error): any => (!error ? ['LoadGroupsById'] : []),
        }),
        updateLoadGroupsStatus: builder.mutation({
            query: ({ loadGroupId, body }: { loadGroupId: any; body: any }) => ({
                url: `/dm/v1/load-groups/${loadGroupId}`,
                method: 'PATCH',
                body,
            }),
        }),
        deleteLoadGroups: builder.mutation<void, { id: string[] }>({
            query: (body: any) => ({
                url: `/dm/v1/load-groups`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['LoadGroups', 'DeleteLoadGroup'],
        }),
        getLoadGroupById: builder.query<any, any>({
            query: ({ loadGroupId }: any) => ({
                url: `/dm/v1/load-groups/${loadGroupId}`,
                method: 'GET',
            }),
            providesTags: ['LoadGroupsById', 'LoadGroups'],
        }),
        setLoadsToLoadGroup: builder.mutation<any, any>({
            query: ({ loadGroupId, loadIds, headers }: any) => ({
                url: `/dm/v1/load-groups/${loadGroupId}/set/loads`,
                method: 'PUT',
                body: { loadIds },
                headers,
            }),
            invalidatesTags: (result, error): any => (!error ? ['LoadGroupsById', 'LoadGroups'] : []),
        }),
        getMultiDevice: builder.query<any, any>({
            query: ({ params }: any) => ({
                url: `ontology/v1/models/category`,
                method: 'GET',
                params,
            }),
        }),
        getDeviceByIdForLoadGroups: builder.query({
            query: (deviceId) => ({
                url: `dm/v1/devices/${deviceId}`,
            }),
        }),
    }),
});

export const {
    useCreateLoadGroupsMutation,
    useGetLoadGroupsListQuery,
    useGetloadGroupsByIdQuery,
    useUpdateLoadGroupsMutation,
    useDeleteLoadGroupsMutation,
    useGetLoadGroupByIdQuery,
    useLazyGetLoadGroupByIdQuery,
    useGetLoadGroupsListAllQuery,
    useSetLoadsToLoadGroupMutation,
    useGetMultiDeviceQuery,
    useLazyGetLoadGroupsListAllQuery,
    useGetDeviceByIdForLoadGroupsQuery,
    useUpdateLoadGroupsStatusMutation,
} = loadGroupsApi;
